<template>
	<div class="header">
		<h2>2019 Holiday Party</h2>
		<a href="https://milkshake.studio" target="_blank"><img src="./images/logo.png" alt="Milkshake" class="logo"></a>
	</div>
</template>

<script>

	export default {
		name: 'Header',
		data() {
			return {};
		},
	}
</script>